import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeContainerComponent, CeEmptyStateImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'ce-core-empty-state-unauthorized',
    imports: [CommonModule, RouterModule, CeEmptyStateImports, CeContainerComponent],
    templateUrl: './empty-state-unauthorized.component.html'
})
export class EmptyStateUnauthorizedComponent {}
